
/**
 * @fileOverview loadDPL module definition
 * @author Pat Shanahan
 * @modified 03/06/17
 */

(function (context) {
	'use strict';

	var require = context.require,
		requirejs = context.requirejs,
		define = context.define;

	define('utility/loadDPL',['require','jquery','lib/Util','utility/scrollIntoView','GlobalEventDispatcher'],function (require) {
		var $ = require('jquery'),
			util = require('lib/Util'),
			scrollIntoView = require('utility/scrollIntoView'),
			GlobalEventDispatcher = require('GlobalEventDispatcher'),
			modInitT = (new Date()).getTime();

		$debug('**** loadDPL Set Up Started, use debug=loadDPL for debug output **** ');
		$debug('**** loadDPL Set Up Started **** ', 'loadDPL'); //syntax: $debug(message, urlParam);
		$debug('loadDPL init time since mmmSettings.js init: ' + (modInitT-window.settingsInitT), 'loadDPL');

		var loadDPL = function($el, oid){
			$debug(' Loading DPL Loader for OID: ' + oid + ' inside container:', 'loadDPL');
			$debug($el, 'loadDPL');
			
            /**
             * A reference to the container DOM element
             *
             * @default null
             * @property $el
             * @type {jQuery}
             * @public
             */
			this.$el = $($el);
			
            /**
             * A reference to the DPL OID value
             *
             * @default null
             * @property oid
             * @type String
             * @public
             */			
			this.oid = oid;
			
            /**
             * Event Dispatcher utility object
             *
             * @default null
             * @property eventDispatcher
             * @type Object
             * @public
             */			
			this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher();
			
            /**
             * A reference to the current locale
             *
             * @default 'en_US'
             * @property locale
             * @type String
             * @public
             */			
			this.locale = this.getLocale();
			
            /**
             * A reference to the current portal environment
             *
             * @default 'portal'
             * @property portalEnv
             * @type String
             * @public
             */			
			this.portalEnv = this.getPortalEnv();
			
            /**
             * A reference to the current DPL name/ID (ex: rG-54-Stackable)
             *
             * @default ''
             * @property dplName
             * @type String
             * @public
             */			
			this.dplName = this.getDPLName();
			
            /**
             * A timestamp for the module init time
             *
             * @property initT
             * @type Int
             * @public
             */			
			this.initT = (new Date()).getTime();
			
            /**
             * A string for the project name (if in edit mode)
             *
             * @property projectName
             * @type String
             * @public
             */			
			this.projectName = this.getProjectName(location.href);
			
			this.options = {
				ajaxbase : '/wps/[portalEnv]/en_US/[projectNamt]3M/JSON/WCMPlaceSelector/helper/?m=ws&l=[locale]&webLoaded=true', // AJAX base URL
				screenbuffer : 1 // How many extra screen heights to serve as a buffer before loading content
				//analyticsBase : 'http://w0177988.usac.mmm.com:3000/add' // Service to send analytics data to (TODO: find a permanent home for this or remove)
			};
			
			this.init();
		};
		
		loadDPL.prototype.init = function(){			
            this.setOptions()
				.setupHandlers();

            return this;
		};
		
		loadDPL.prototype.getLocale = function(){
            var locale = 'en_US',
				urlSplit = [];
			
			if(SETTINGS.LOCALE !== undefined){ // Look for SETTINGS.LOCALE property locale
				locale = SETTINGS.LOCALE;
			}else if($('meta[name="DCSext.locale"]').length > 0){ // Otherwise check WT tags
				locale = $('meta[name="DCSext.locale"]').attr('content');
			} else{ // If all else fails, try to parse it from the URL
				urlSplit = window.location.pathname.split('/');
				
				for(var i=0, l=urlSplit.length; i<l; i++){
					if(urlSplit[i].indexOf('_') === 2){
						locale = urlSplit[i];
					}
				}
			}

            return locale;
		};
		
		loadDPL.prototype.getPortalEnv = function(){
            var portalEnv = 'portal',
				urlSplit = [];
			
			urlSplit = window.location.pathname.split('/');
				
			for(var i=0, l=urlSplit.length; i<l; i++){
				if(urlSplit[i].indexOf('my3M') > -1 || urlSplit[i].indexOf('myportal') > -1){
					portalEnv = 'myportal';
				}
			}

            return portalEnv;
		};
		
		loadDPL.prototype.getDPLName = function(){
			var dplName = '',
				dplRegex = /(r\D-\d\d-[a-zA-Z0-9]*[^\s])+/g,
				match = this.$el.attr('class').match(dplRegex);
			
			// If the DPL contains two matches, the second one is most likely the one we want
			if(match !== null && match[1] !== undefined){
				dplName = match[1];
			} else if(match !== null && match[0] !== undefined){
				dplName = match[0];
			};
			
			$debug(' Initializing loadDPL for placement of ' + dplName, 'loadDPL');

            return dplName;
		};
		
		loadDPL.prototype.getProjectName = function(curUrl){
			var projectName = '',
				projectRegex = /(\$project\/[^\/]+\/)/,
				match = curUrl.match(projectRegex);
			
			// There should be only one match
			if(match !== null && match[0] !== undefined){
				projectName = match[0];
			}
			
			$debug(' Storing project name: ' + projectName, 'loadDPL');

            return projectName;
		};
		
		loadDPL.prototype.setOptions = function(){
			$debug(' In setOptions...', 'loadDPL');
			$debug('  Base options:', 'loadDPL');
			$debug(this.options, 'loadDPL');
			$debug('  Override options:', 'loadDPL');
			$debug(this.$el.data(), 'loadDPL');
			
			$.extend(this.options, this.$el.data());
			
			$debug('  Final options:', 'loadDPL');
			$debug(this.options, 'loadDPL');
			
			return this;
		};
		
		loadDPL.prototype.setupHandlers = function(){
			var eventName = 'scroll_' + this.oid.replace(/-/g, '');
			
			$debug(' ' + this.oid + ' init time since mmmSettings.js init: ' + (this.initT-window.settingsInitT), 'loadDPL');
			
			// Create new scroll into view event listener and fire build once triggered, also check to see if it's in view on the initial load
			scrollIntoView.addScrollListener(this.$el, eventName, this.options.screenbuffer);
			this.eventDispatcher.subscribe(eventName, this.build.bind(this));
			scrollIntoView.checkEventListeners();
			
			$debug(' Listening for scroll event name: ' + eventName, 'loadDPL');
			
			return this;
		};
		
		loadDPL.prototype.build = function(){
			$debug(' DPL OID ' + this.oid + ' is in view, firing build...', 'loadDPL');
			
			this.getContents(this.oid);
			
			return this;
		};
		
		loadDPL.prototype.getContents = function(oid){
			var self = this,
				ajaxUrl = this.formatAjaxUrl(oid);
			
			$.ajax({
				url: ajaxUrl,
				dataType: 'text',
				success: function(data, status, jqxhr){
					$debug('  AJAX Successful, status: ' + status, 'loadDPL');
					
					self.popContent(data);
				}
			});
			
			return this;
		};
		
		loadDPL.prototype.popContent = function(data){
			var contentLoadedT = (new Date()).getTime();
			
			$debug(' Adding DPL response contents to container', 'loadDPL');
			$debug(data, 'loadDPL');
			$debug(' Container:', 'loadDPL');
			$debug(this.$el, 'loadDPL');
			
			this.$el.replaceWith(data);
			
			$debug(' ' + this.oid + ' complete time since mmmSettings.js init: ' + (contentLoadedT-window.settingsInitT), 'loadDPL');
			
			// This might be useful for reporting analytics to a database if the structure is put in place
			/*
			if(urlHash['debug'] == 'loadDPL'){
				this.sendData(contentLoadedT-window.settingsInitT);
			}
			*/
			this.initComponents();
			return this;
		};
        
        // New function initComponents will trigger any factors that need a retrigger on content load
        loadDPL.prototype.initComponents = function(){
            // Insert picturefill init here
            window.picturefill();                    
        };
      
        loadDPL.prototype.formatAjaxUrl = function(oid){
			var ajaxUrl = '',
				paramSep = '?';
			
			if(this.options.ajaxbase.indexOf('?') > -1){
				paramSep = '&';
			}
			
			ajaxUrl = this.options.ajaxbase + paramSep + 'oid=' + oid;
			
			if(ajaxUrl.indexOf('[locale]') > -1){
				ajaxUrl = ajaxUrl.replace('[locale]', this.locale);
			}
			
			if(ajaxUrl.indexOf('[portalEnv]') > -1){
				ajaxUrl = ajaxUrl.replace('[portalEnv]', this.portalEnv);
			}
            
            if(ajaxUrl.indexOf('[projectNamt]') > -1){
                ajaxUrl = ajaxUrl.replace('[projectNamt]', this.projectName);
            }
			
			if(urlHash['clientDPLBase'] === 'local'){
				ajaxUrl = 'service/' + oid;
			}
			
			$debug(' Firing AJAX request for DPL oid: ' + oid, 'loadDPL');
			$debug('  AJAX URL: ' + ajaxUrl, 'loadDPL');
			
        	return ajaxUrl;
        };
		
		loadDPL.prototype.sendData = function(t){
			var self = this,
				ajaxUrl = this.options.analyticsBase;
			
			$.ajax({
				url: ajaxUrl,
				method: 'POST',
				data: {
					dplID: this.dplName,
					loadTime: t
				},
				success: function(data, status, jqxhr){
					$debug('  Analytics Successful, status: ' + status, 'loadDPL');
				}
			});
		};
		
		return loadDPL;

	});

}(MMMRequire));